import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[redText]',
})
export class RedTextDirective {
  @Input() redText: boolean;

  constructor(el: ElementRef) {
    setTimeout(() => {
      if (this.redText) {
        el.nativeElement.style.color = '#ff0000';
        el.nativeElement.style.fontWeight = 'bold';
      }
    });
  }
}
